import React from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import Dropdown from "aldoo-ra/Dropdown"
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline"

// Reuse site-theme tokens for the page nav buttons so the controls stay
// readable on both light and dark themes (the older admin variants were
// hardcoded to admin colors).
const navBtnCls =
  "h-[40px] flex items-center justify-center text-text bg-neutral border border-bordered hover:bg-neutral_1 disabled:opacity-40 rounded-full px-3 transition-colors"

const PaginationControls = ({
  rowsPerPage,
  onRowsPerPageChange,
  startIndex,
  endIndex,
  totalItems,
  onPageChange,
  page,
  totalPages,
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center mt-2 gap-2 px-3 pb-3">
      {/* Mobile: Top row with dropdown on left, buttons on right */}
      <div className="flex md:hidden w-full justify-between items-center">
        {/* Rows per page dropdown - left side on mobile */}
        <div className="flex flex-row items-center">
          <Dropdown
            menuPosition="top"
            className="w-[100px]"
            value={rowsPerPage}
            options={[10, 20, 50, 100]}
            onChange={onRowsPerPageChange}
            variant="site"
          />
        </div>

        {/* Navigation buttons - right side on mobile */}
        <div className="flex flex-row gap-2">
          <button
            onClick={() => onPageChange(Math.max(page - 1, 1))}
            disabled={page === 1}
            className={navBtnCls}
          >
            <ArrowLeftIcon className="w-5 h-5" />
          </button>
          <button
            onClick={() => onPageChange(Math.min(page + 1, totalPages))}
            disabled={page === totalPages}
            className={navBtnCls}
          >
            <ArrowRightIcon className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Desktop layout */}
      <div className="hidden md:flex flex-row items-center w-[150px]">
        <Dropdown
          menuPosition="top"
          className="w-[150px]"
          value={rowsPerPage}
          options={[10, 20, 50, 100]}
          onChange={onRowsPerPageChange}
          variant="site"
        />
      </div>

      {/* Items count - center on desktop, bottom on mobile */}
      <Typography className="text-text mt-1 md:mt-0">
        {`${(startIndex + 1).toLocaleString()}–${endIndex.toLocaleString()} of ${totalItems.toLocaleString()}`}
      </Typography>

      {/* Navigation buttons - desktop only (hidden on mobile since they're in top row) */}
      <div className="hidden md:flex flex-row gap-2">
        <button
          onClick={() => onPageChange(Math.max(page - 1, 1))}
          disabled={page === 1}
          className={navBtnCls}
        >
          <ArrowLeftIcon className="w-5 h-5" />
        </button>
        <button
          onClick={() => onPageChange(Math.min(page + 1, totalPages))}
          disabled={page === totalPages}
          className={navBtnCls}
        >
          <ArrowRightIcon className="w-5 h-5" />
        </button>
      </div>
    </div>
  )
}

export default PaginationControls
